import React from 'react';
import EventEmitter from 'events';

import util from '../tools/util';
import UserStore from './user_store';

export default {
  once,
  addChangeListener,
  removeChangeListener,
  init,
  getMediaList,
  getVolumeList,
  useMediaList,
  useVolumeList,
  fetchMedia,
  fetchVolume,
};

const g_mediaMap = new Map<number, any[]>();
const g_volumeMap = new Map<number, any[]>();

const g_eventEmitter = new EventEmitter();
const CHANGE_EVENT = 'change';
function once(callback) {
  g_eventEmitter.once(CHANGE_EVENT, callback);
}
function addChangeListener(callback) {
  g_eventEmitter.on(CHANGE_EVENT, callback);
}
function removeChangeListener(callback) {
  g_eventEmitter.removeListener(CHANGE_EVENT, callback);
}
function _emit(...args) {
  g_eventEmitter.emit(CHANGE_EVENT, ...args);
}
function init(done) {
  done?.();
}
function getMediaList(media_id: number) {
  return g_mediaMap.get(media_id);
}
function getVolumeList(volume_id: number) {
  return g_volumeMap.get(volume_id);
}
function _subscribe(callback: any) {
  addChangeListener(callback);
  return () => {
    removeChangeListener(callback);
  };
}
export function useMediaList(media_id: number) {
  const _get = React.useCallback(() => getMediaList(media_id), [media_id]);
  return React.useSyncExternalStore(_subscribe, _get);
}
export function useVolumeList(volume_id: number) {
  const _get = React.useCallback(() => getVolumeList(volume_id), [volume_id]);
  return React.useSyncExternalStore(_subscribe, _get);
}
function fetchMedia(params: any, done?: any) {
  const { org_id, media_id } = params;
  const opts = { url: `/api/1/org/${org_id}/audit_event/media/${media_id}` };
  UserStore.get(opts, (err, body) => {
    if (err) {
      util.errorLog('AuditStore.fetch: err:', err, body);
    } else {
      const key = media_id;
      const old = g_mediaMap.get(key);
      if (!util.deepEqual(old, body.audit_list)) {
        g_mediaMap.set(key, body.audit_list);
        _emit('update');
      }
    }
    done?.(err, body);
  });
}
function fetchVolume(params: any, done?: any) {
  const { org_id, volume_id } = params;
  const opts = { url: `/api/1/org/${org_id}/audit_event/volume/${volume_id}` };
  UserStore.get(opts, (err, body) => {
    if (err) {
      util.errorLog('AuditStore.fetch: err:', err, body);
    } else {
      const key = volume_id;
      const old = g_volumeMap.get(key);
      if (!util.deepEqual(old, body.audit_list)) {
        g_volumeMap.set(key, body.audit_list);
        _emit('update');
      }
    }
    done?.(err, body);
  });
}
